import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { ConfigurationSectionCreateRequest, ConfigurationSectionPatchInBatchRequest, ConfigurationSectionResponse } from '@/modules/configurationModule/detail/local-laboratory-module/sections/services/configuration-section/configuration-section.dto'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class ConfigurationSectionService {
    async create(laboratoryId: number, request: ConfigurationSectionCreateRequest): Promise<ConfigurationSectionResponse> {
        const response = await axios.post<ConfigurationSectionResponse>(`/configuration/laboratories/${laboratoryId}/sections`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationSectionResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationSectionResponse>>(`/configuration/laboratories/${laboratoryId}/sections`, { ...filterModel }, { params })
        return response.data
    }

    async get(sectionId: number, laboratoryId: number): Promise<ConfigurationSectionResponse> {
        const response = await axios.get<ConfigurationSectionResponse>(`/configuration/laboratories/${laboratoryId}/sections/${sectionId}`)
        return response.data
    }

    async delete(laboratoryId: number, request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/sections/batch`, { data: request })
        return response.data
    }

    async patch(laboratoryId: number, request: ConfigurationSectionPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/sections/batch`, request)
        return response.data
    }
}

export const configurationSectionService = new ConfigurationSectionService()
